import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  Input
} from '@angular/core';
import { CommentsService } from '@ml/comments/services/comments.service';
import { CommentsComponent } from '@ml/comments/containers';
import { SidenavService } from '@ml/core/services';
import { ResourceType } from '@ml/shared/types/resource-type';

@Component({
  selector: 'ml-comments-icon',
  template: `
    <button
      [disabled]="!resource || !resourceId"
      mat-icon-button
      (click)="onOpen()"
    >
      <mat-icon svgIcon="chat"></mat-icon>
      <span *ngIf="commented" class="badge"></span>
    </button>
  `,
  styleUrls: ['./comments-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommentsIconComponent {
  @Input() commented: boolean;
  @Input() resource: ResourceType;
  @Input() resourceId: number;
  @Input() title: string;

  constructor(
    private commentsService: CommentsService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private sidenavService: SidenavService,
    private cdr: ChangeDetectorRef
  ) {}

  onOpen() {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(
      CommentsComponent
    );
    this.commentsService.setDetails(this.resource, this.resourceId, this.title);
    this.sidenavService.open(componentFactory);

    this.subscribe();
  }

  private subscribe() {
    this.commentsService
      .subscribeCommentAdded(this.resourceId, this.resource)
      .subscribe(() => {
        this.commented = true;
        this.cdr.detectChanges();
      });

    this.commentsService
      .subscribeCommentRemoved(this.resourceId, this.resource)
      .subscribe(() => {
        this.commented = false;
        this.cdr.detectChanges();
      });
  }
}
